<span *ngFor="let option of options; let i = index;" class="pill-item" [class.active]="option.isActive"
  (click)="togglePill(i)">
  {{option.label}}
</span>
